// extracted by mini-css-extract-plugin
export default {"number-counter":"_counter-number-counter-73e457","number":"_counter-number-a39e8a"};